import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { createError } from '@sonar/errors';

import { Query, Result } from '../Reports/types';

import {
  failedCustomerTabCreditsInfo,
  requestCustomerTabCreditsInfo,
  succeededCustomerTabCreditsInfo,
} from './reducer';
import { getCustomerTabCreditsPerStoreAsync } from './services';
import { CustomerTabCreditInfo } from './types';

export function* getCustomerTabCreditsSaga({ payload: query }: PayloadAction<Query>): SagaIterator {
  try {
    const result = (yield call(
      getCustomerTabCreditsPerStoreAsync,
      query,
    )) as Result<CustomerTabCreditInfo>;

    yield put(succeededCustomerTabCreditsInfo(result));
  } catch (e) {
    yield put(
      failedCustomerTabCreditsInfo({
        storeIds: query.storeIds,
        error: createError(e),
      }),
    );
  }
}

export default function* CustomerTabCreditsWatcher(): SagaIterator {
  yield takeLatest(requestCustomerTabCreditsInfo.type, getCustomerTabCreditsSaga);
}
